import { ShieldCheck } from 'lucide-react';
import WhatsAppButton from '@/components/WhatsAppButton';
import FadeIn from '@/components/FadeIn';

function Hero() {
  return (
    <section
      id="top"
      className="relative pt-28 pb-16 sm:pt-36 sm:pb-20 overflow-hidden bg-gradient-to-br from-slate-950 via-blue-950 to-blue-800">

      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 85% 8%, rgba(59,130,246,0.28), transparent 45%), radial-gradient(circle at 8% 95%, rgba(37,99,235,0.18), transparent 40%)'
        }} />

      <div
        className="absolute inset-0 pointer-events-none opacity-[0.12]"
        style={{
          backgroundImage: 'linear-gradient(rgba(96,165,250,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(96,165,250,0.5) 1px, transparent 1px)',
          backgroundSize: '48px 48px'
        }} />

      <div
        className="absolute inset-0 pointer-events-none opacity-[0.08]"
        style={{
          backgroundImage: 'repeating-linear-gradient(135deg, rgba(255,255,255,0.6) 0px, rgba(255,255,255,0.6) 1px, transparent 1px, transparent 90px)'
        }} />

      <div className="relative max-w-6xl mx-auto px-6 sm:px-8">
        <FadeIn className="max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-blue-400/30 bg-blue-500/10 px-4 py-1.5 text-xs font-medium tracking-wide text-blue-100 uppercase mb-6">
            <ShieldCheck className="w-3.5 h-3.5" strokeWidth={2} />
            Intermediação especializada de ativos digitais
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-[1.05]">Compra e venda de propriedades digitais com segurança

          </h1>
          <p className="mt-5 text-lg sm:text-xl text-white/70 leading-relaxed max-w-2xl">
            Adquirimos projetos digitais consolidados e encontramos o novo dono ideal para cada um deles — com avaliação criteriosa, curadoria e transferência 100% segura.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <WhatsAppButton label="Fale conosco agora" variant="primary" size="lg" />
            <p className="text-sm text-white/50">
              Atendimento direto e confidencial via WhatsApp.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>);

}

export default Hero;